import { createSelector } from 'reselect';

const getState = (state) => state.directOrder.ui;

const getIsFetching = createSelector(getState, (ui) => ui.isFetching);

const getIsSubmitting = createSelector(getState, (ui) => ui.isSubmitting);

export default {
  getIsFetching,
  getIsSubmitting,
};
